import React, { FC } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ConfirmDeleteOrUnlinkModal: FC<ConfirmDeleteOrUnlinkModal> = ({
  onUnlinkDevice,
  onDeleteDevice,
  showUnlinkBtn,
  isLoading,
}: ConfirmDeleteOrUnlinkModal) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="mb-2">
        {showUnlinkBtn
          ? t('device_inventory_delete_unlink_modal_body')
          : t('device_inventory_delete_modal_body')}
      </div>

      <div className="flex justify-between w-full gap-2">
        <Button
          color="error"
          variant="contained"
          disableElevation
          onClick={onDeleteDevice}
          disabled={isLoading}
          fullWidth
        >
          {t('delete')}
        </Button>
        {showUnlinkBtn && onUnlinkDevice && (
          <Button
            color="primary"
            variant="contained"
            disableElevation
            disabled={isLoading}
            fullWidth
            onClick={onUnlinkDevice}
          >
            {t('unlink')}
          </Button>
        )}
      </div>
    </>
  );
};

interface ConfirmDeleteOrUnlinkModal {
  onDeleteDevice: () => void;
  isLoading: boolean;
  onUnlinkDevice?: () => void;
  showUnlinkBtn: boolean;
}

export default ConfirmDeleteOrUnlinkModal;
